import type { Card, Suit, Rank } from "./types.ts";
import { hashSeed, mulberry32, shuffleInPlace } from "./rng.ts";

const SUITS: readonly Suit[] = ["S", "H", "D", "C"];

export function createDeck(): Card[] {
  const deck: Card[] = [];
  let id = 0;
  for (const suit of SUITS) {
    for (let r = 1 as Rank; r <= 13; r = (r + 1) as Rank) {
      deck.push({ id: id++, suit, rank: r as Rank, faceUp: false });
    }
  }
  return deck;
}

export function shuffledDeck(seed: string): Card[] {
  const deck = createDeck();
  const rng = mulberry32(hashSeed(seed));
  shuffleInPlace(deck, rng);
  return deck;
}
